import { checkHttpStatus } from './deviceUtils';

export const getAdminSettings = () => (
  fetch('/get_admin_settings', { method: 'GET', credentials: 'same-origin' })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then(response => (Promise.resolve(JSON.parse(response))))
    .catch(err => (Promise.reject(err)))
);

export const changeAdminSettings = (settings = {}) => (
  fetch('/change_admin_settings', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    credentials: 'same-origin',
    body: JSON.stringify(settings)
  })
    .then(checkHttpStatus)
    .then(response => response.text())
    .then((response) => {
      const parsedJSON = JSON.parse(response);
      if (parsedJSON.error) {
        return Promise.reject(parsedJSON);
      }
      return Promise.resolve(parsedJSON);
    })
    .catch(err => (Promise.reject(err)))
);

export default {
  getAdminSettings,
  changeAdminSettings
}


// WEBPACK FOOTER //
// ./src/utils/adminUtils.js